import { IPropertyRiskDetails } from '../types';

const PROPERTY_LINE_CODES = ['2', '8', '23', '26'];

export const isPropertyLineCode = (lineCode?: string): boolean =>
  PROPERTY_LINE_CODES.includes(String(lineCode ?? ''));

const parseDistributionAmount = (value: unknown): number => {
  if (value == null || value === '') return 0;
  const n = Number(String(value).replace(/,/g, ''));

  return Number.isNaN(n) ? 0 : n;
};

const round3 = (n: number): number => Math.round(n * 1000) / 1000;

export function sumCoverDistributionForPlanCover(
  propertyRiskDetails: IPropertyRiskDetails[] | undefined,
  planCoverId: string
): { sumInsured: number; premium: number } {
  if (!planCoverId) return { sumInsured: 0, premium: 0 };

  const id = String(planCoverId);
  let sumInsured = 0;
  let premium = 0;

  for (const risk of propertyRiskDetails ?? []) {
    for (const pc of risk.planCoverPropertyDetails ?? []) {
      if (String(pc.planCoverID) !== id) continue;
      sumInsured += parseDistributionAmount(pc.sumInsured);
      premium += parseDistributionAmount(pc.premium);
    }
  }

  return { sumInsured: round3(sumInsured), premium: round3(premium) };
}
